'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bell-on';
var width = 640;
var height = 512;
var aliases = [128365];
var unicode = 'f8fa';
var svgPathData = 'M312 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24 0 .2c84.6 4.2 152 74.1 152 159.8l0 36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7l-384.6 0C110.2 416 96 401.8 96 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C145.8 311 160 270.4 160 228.6l0-36.6c0-85.7 67.4-155.6 152-159.8l0-.2 0-24zm8 40c-79.5 0-144 64.5-144 144l0 36.6c0 45.4-15.5 89.5-43.8 124.9l-16.7 20.9c-2.2 2.8-3.4 6.2-3.4 9.8c0 8.7 7 15.7 15.7 15.7l384.6 0c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C479.5 318.1 464 274.1 464 228.6l0-36.6c0-79.5-64.5-144-144-144zM272 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8zM0 184c0-4.4 3.6-8 8-8l96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 192c-4.4 0-8-3.6-8-8zm536-8l96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8zM607.2 36.4c2 4 .4 8.8-3.6 10.7l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7l80-40c4-2 8.8-.4 10.7 3.6zM36.4 47.2c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6l80 40c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellOn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;